import { theme } from 'gradoo-theme'
import { useEffect, useState } from 'react'

import IslandModal from 'shared/components/modals/IslandModal'
import Button, { Intents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import Text from 'shared/ui/Text'

type SwithchTemplateWarningModalProps = {
  isOpen: boolean
  onClose: () => void
  onSwitchTemplate: () => void
}

const SwitchTemplateWarningModal: React.FC<
  SwithchTemplateWarningModalProps
> = ({ isOpen, onClose, onSwitchTemplate }) => {
  const [timer, setTimer] = useState(3)

  useEffect(() => {
    if (isOpen) {
      setTimer(3)
    }
  }, [isOpen])

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer(timer - 1)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [timer])

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={onClose}
      width={400}
      titleId="Panel.switchCoverTemplate.warningModal.title"
    >
      <Flex direction="column">
        <Text
          size={16}
          color={theme.color.error}
          align="center"
          id="Panel.switchCoverTemplate.warningModal.description"
          marginBottom={16}
        />

        <Text
          size={16}
          align="center"
          id="Panel.switchCoverTemplate.warningModal.ifYouWantToTryTheNewTemplate"
        />

        <Flex marginTop={36} justifyContent="center" columnGap={8}>
          <Button
            intent={Intents.neutral}
            labelId={'Panel.switchCoverTemplate.warningModal.button.cancel'}
            onClick={onClose}
          />
          <Button
            intent={timer > 0 ? Intents.neutral : Intents.danger}
            labelId={
              timer > 0
                ? `Panel.switchCoverTemplate.warningModal.button.switchTemplateIn`
                : `Panel.switchCoverTemplate.warningModal.button.switchTemplate`
            }
            labelOptions={{
              timer: timer.toString()
            }}
            isDisabled={timer > 0}
            onClick={onSwitchTemplate}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
}

export default SwitchTemplateWarningModal
